// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__26i2G","left":"StickyBox_left__1Bj9M","right":"StickyBox_right__2VAjH"};